import NoResultsFoundConnector from './NoResultsFoundConnector.jsx'
import NoResultsFound from './NoResultsFound.jsx'

export default NoResultsFoundConnector
export { NoResultsFound }
